import axios, { AxiosResponse } from 'axios';
import queryString from 'qs';

import config from '@/config';
import { processJuniorRequest } from '@/shared/services/juniorApi';
import { getAccessToken } from '@/shared/services/accessToken';
import { joinBaseUrl, isAbsoluteUrl } from '@/shared/utils/url';

import type { Href } from '@/shared/utils/href';

export enum RequestMethod {
	GET = 'GET',
	POST = 'POST',
	PUT = 'PUT',
	PATCH = 'PATCH',
	DELETE = 'DELETE',
}

const serializeParams = (params: unknown) => queryString.stringify(params, { arrayFormat: 'brackets' });

const buildRequestUrl = (url: string) => {
	if (isAbsoluteUrl(url)) {
		return url;
	}

	return encodeURI(joinBaseUrl(config.api_url, url));
};

export async function processRequest(
	url: string = '',
	method: RequestMethod = RequestMethod.GET,
	data: Record<string, any> | FormData = {},
	additionalHeaders: Record<string, string> = {},
): Promise<AxiosResponse<any>> {
	const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;
	const headers: Record<string, string> = {
		...additionalHeaders,
	};

	if (!isFormData && method !== RequestMethod.GET) {
		headers['Content-Type'] = headers['Content-Type'] || 'application/json';
	}

	if (isFormData && headers['Content-Type']) {
		delete headers['Content-Type'];
	}

	const token = getAccessToken();
	const hasAuthorizationHeader = headers.Authorization != null || headers.authorization != null;

	if (token && !hasAuthorizationHeader) {
		headers.Authorization = `Bearer ${token}`;
	}

	return axios({
		headers,
		method,
		params: method === RequestMethod.GET ? data : {},
		data: method === RequestMethod.GET ? undefined : data,
		paramsSerializer: serializeParams,
		url: buildRequestUrl(url),
		withCredentials: !hasAuthorizationHeader,
	});
}

export function processJuniorHrefRequest(request: Href, data: Record<string, unknown> = {}): Promise<AxiosResponse> {
	return processJuniorRequest({
		url: request.href,
		method: request.method,
		params: request.method === 'GET' ? data : undefined,
		data: request.method === 'GET' ? undefined : data,
		paramsSerializer: serializeParams,
	});
}

export function processSpeechRequest(url: string): Promise<AxiosResponse<{ url: string }>> {
	return axios.get(url, { withCredentials: false });
}
